module.exports = __webpack_public_path__ + "static/media/jackbanner_sm1.d1449be0.png";